(function () {
  'use strict';

  function parseVariants(form) {
    var data = form.querySelector('[data-leha-pricing-variants]');
    if (!data) return null;
    if (data.__lehaParsed) return data.__lehaParsed;
    try {
      data.__lehaParsed = JSON.parse(data.textContent || '[]');
    } catch (error) {
      data.__lehaParsed = [];
    }
    return data.__lehaParsed;
  }

  function setValue(form, selector, value) {
    var input = form.querySelector(selector);
    if (input) input.value = value == null ? '' : String(value);
  }

  function sync(form) {
    if (!form || !form.querySelector('[data-leha-pricing-variants]')) return;
    var idField = form.querySelector('[name="id"]');
    if (!idField) return;

    var variants = parseVariants(form);
    if (!Array.isArray(variants)) return;

    var id = String(idField.value || '');
    var variant = variants.find(function (item) {
      return String(item.id) === id;
    });
    if (!variant) return;

    setValue(form, '[data-leha-snapshot-country]', variant.country_code);
    setValue(form, '[data-leha-snapshot-price]', variant.local_unit_price);
    setValue(form, '[data-leha-snapshot-currency]', variant.local_currency);
    setValue(form, '[data-leha-snapshot-source]', variant.pricing_source);
    setValue(form, '[data-leha-snapshot-offer]', variant.offer_handle || '');
  }

  document.addEventListener('change', function (event) {
    var form = event.target && event.target.closest ? event.target.closest('form') : null;
    sync(form);
  }, true);

  document.addEventListener('click', function (event) {
    var form = event.target && event.target.closest ? event.target.closest('form') : null;
    sync(form);
  }, true);

  document.addEventListener('submit', function (event) {
    sync(event.target);
  }, true);
})();